import React from 'react'

export default function Nfts() {
  return (
    <div>Nfts</div>
  )
}
